import Axios from '../../config/axios';

export function getDensityVerbiageByFacility(facilityID) {
    return Axios.get('/api/GetDensityVerbiageByFacility', {
        params: {
            facilityID
        }
    }).then(response => response.data);
}

export function createDensityLetterVerbiage(item) {
    return Axios.post('/api/CreateDensityLetterVerbiage', item).then(response => response.data);
}

export function updateDensityLetterVerbiage(item) {
    return Axios.post('/api/UpdateDensityLetterVerbiage', item).then(response => response.data);
}

export function deleteDensityLetterVerbiage(facilityID, breastDensityID) {
    return Axios.delete('/api/DeleteDensityLetterVerbiage', {
        params: {
            facilityID,
            breastDensityID
        }
    }).then(response => response.data);
}
